import deleteIcon from "@assets/svg/delete.svg";
import close from "@assets/svg/close.svg";
import expand from "@assets/svg/expand.svg";

type locationType = "startLocation" | "endLocation" | "blackSpot";

const nocLocationElement = (
  long: string,
  lat: string,
  chainage: string,
  type: locationType
) => {
  const [latVal, longVal] = [
    parseFloat(lat).toFixed(2),
    parseFloat(long).toFixed(2),
  ];
  return `<div class="location-marker location-marker-container">
        ${
          type === "startLocation"
            ? `<div class="location-hd">Start Location <img class="close-icon" src="${close}" /> </div>`
            : type === "endLocation"
            ? `<div class="location-hd">End Location <img class="close-icon" src="${close}" /> </div>`
            : `<div class="location-hd">Black spot Location<img class="close-icon" src="${close}" /> </div>`
        } 
        <div class="coord-section">
            <div class="coord-inner wd-lg"> <span class="inner-hd">Latitude</span>  <br/> <span class="inner-subhd">${longVal}</span> </div>
            <div class="coord-inner"><span class="inner-hd">Longitude</span> <br/> <span class="inner-subhd">${latVal}</span></div>
            <div class="coord-inner"><span class="inner-hd">Chainage</span>  <br/> <span class="inner-subhd">${chainage}</span></div>
        </div>
    </div>`;
};

const startLocationElement = (
  long: string,
  lat: string,
  chainage: string,
  hideRemovePin: boolean,
  type: locationType
) => {
  const [latVal, longVal] = [
    parseFloat(lat).toFixed(2),
    parseFloat(long).toFixed(2),
  ];
  return `<div class="location-marker location-marker-container">
        ${
          type === "startLocation"
            ? `<div class="location-hd">Start Location <img class="close-icon" src="${close}" /> </div>`
            : type === "endLocation"
            ? `<div class="location-hd">End Location <img class="close-icon" src="${close}" /> </div>`
            : `<div class="location-hd">Black spot Location<img class="close-icon" src="${close}" /> </div>`
        } 
        <div class="coord-section">
            <div class="coord-inner wd-lg"> <span class="inner-hd">Latitude</span>  <br/> <span class="inner-subhd">${longVal}</span> </div>
            <div class="coord-inner"><span class="inner-hd">Longitude</span> <br/> <span class="inner-subhd">${latVal}</span></div>
            <div class="coord-inner"><span class="inner-hd">Chainage</span>  <br/> <span class="inner-subhd">${chainage}</span></div>
        </div>
        ${!hideRemovePin ? `<div><button id="start-pin" class="remove-bin"><img class="delete-icon" src="${deleteIcon}" />Remove Pin</button></div>` : ''}
    </div>`;
};

const endLocationElement = (
  long: string,
  lat: string,
  chainage: string,
  hideRemovePin: boolean,
  type: locationType
) => {
  const [latVal, longVal] = [
    parseFloat(lat).toFixed(2),
    parseFloat(long).toFixed(2),
  ];
  return `<div class="location-marker location-marker-container">
        ${
          type === "startLocation"
            ? `<div class="location-hd">End Location <img class="close-icon" src="${close}" /> </div>`
            : type === "endLocation"
            ? `<div class="location-hd">End Location <img class="close-icon" src="${close}" /> </div>`
            : `<div class="location-hd">Black spot Location<img class="close-icon" src="${close}" /> </div>`
        } 
        <div class="coord-section">
            <div class="coord-inner wd-lg"> <span class="inner-hd">Latitude</span>  <br/> <span class="inner-subhd">${longVal}</span> </div>
            <div class="coord-inner"><span class="inner-hd">Longitude</span> <br/> <span class="inner-subhd">${latVal}</span></div>
            <div class="coord-inner"><span class="inner-hd">Chainage</span>  <br/> <span class="inner-subhd">${chainage}</span></div>
        </div>
        ${!hideRemovePin ? `<div><button id="end-pin" class="remove-bin"><img class="delete-icon" src="${deleteIcon}" />Remove Pin</button></div>` : ''}
    </div>`;
};

const strechElement = (
  uccNm: string,
  uccTxt: string,
  km: string,
  location: string,
  workType: string
) => {
  return `<div class="location-marker location-marker-container">
        <div class="inner-hd noMargin">${uccNm} <img class="expand-icon" src="${expand}" /> <img class="close-icon" src="${close}" /> </div>
        <div class="location-marker-txt">${uccTxt}</div>
        <div><span class="inner-hd">Length :</span> <span class="location-shd"> ${km} Kms</span></div>
        <div><span class="inner-hd">PIU :</span> <span class="location-shd"> ${location}</span></div>
        <div><span class="inner-hd">Type :</span>  <span class="location-shd"> ${workType}</span></div>
    </div>`;
};

const segmentElement = (
  segmentNm: string,
  km: string,
  startChainage: string,
  endChainage: string
) => {
  return `<div class="location-marker location-marker-container">
        <div class="inner-hd noMargin">${segmentNm} <img class="close-icon" src="${close}" /> </div>
        <div class="coord-section">
            <div class="coord-inner wd-lg"> <span class="inner-hd">Start Chainage</span>  <br/> <span class="inner-subhd">${startChainage}</span> </div>
            <div class="coord-inner"><span class="inner-hd">End Chainage</span> <br/> <span class="inner-subhd">${endChainage}</span></div>
        </div>
        <div><span class="inner-hd">Length :</span> <span class="location-shd"> ${km} Kms</span></div>
    </div>`;
};

const contractElementView = (location: string, contractNum: string) => {
  return `<div class="location-marker location-marker-container-md">
        <div class="inner-hd noMargin">${location}</div>
        <div class="location-marker-txt">${contractNum} ongoing contracts</div>
    </div>`;
};

const NocMarkerElement = (
  long: string,
  lat: string,
  chainage: string,
) => {
  const [latVal, longVal] = [
    parseFloat(lat).toFixed(2),
    parseFloat(long).toFixed(2),
  ];
  return `<div class="location-marker location-marker-container-lg">
        <div class="location-hd">Your Location </div>
        <div class="coord-section-lg">
            <div class="coord-inner wd-lg"> <span class="inner-hd">Latitude</span>  <br/> <span class="inner-subhd">${latVal}</span> </div>
            <div class="coord-inner"><span class="inner-hd">Longitude</span> <br/> <span class="inner-subhd">${longVal}</span></div>
            <div class="coord-inner"><span class="inner-hd">Chainage</span> <br/> <span class="inner-subhd">${chainage}</span></div>
        </div>
    </div>`;
};
// <div class="coord-inner wd-lg"> <span class="inner-hd">Route</span>  <br/> <span class="inner-subhd">${route}</span> </div>

export {
  startLocationElement,
  endLocationElement,
  strechElement,
  contractElementView,
  segmentElement,
  NocMarkerElement,
  nocLocationElement
};
